const IconNames: { [Keys: string]: string } = {
  ArrowLeft: 'arrow-left',
  ArrowsCircle: 'arrows-circle',
  Arrows: 'arrows',
  Bold: 'bold',
  Check: 'check',
  CheckCircle: 'check-circle',
  ChevronDown: 'chevron-down',
  ChevronLeft: 'chevron-left',
  ChevronRight: 'chevron-right',
  ChevronUp: 'chevron-up',
  ChevronUpDown: 'chevron-up-and-down',
  Cog: 'cog',
  Copy: 'copy',
  Dashboard: 'dashboard',
  Edit: 'edit',
  Embed: 'embed',
  Export: 'export',
  Eye: 'eye',
  Folder: 'folder',
  HelpCircle: 'help-circle',
  Italic: 'italic',
  List: 'list',
  ListNumbered: 'list-numbered',
  ListBulleted: 'list-bulleted',
  Menu: 'menu',
  MoneyBill: 'money-bill',
  ParagraphLeft: 'paragraph-left',
  ParagraphRight: 'paragraph-right',
  ParagraphCenter: 'paragraph-center',
  Pause: 'pause',
  PauseCircle: 'pause-circle',
  PlayCircle: 'play-circle',
  PlusSquare: 'plus-square',
  Search: 'search',
  StripeLogo: 'stripe-logo',
  Trash: 'trash',
  Underline: 'underline',
  User: 'user',
  Users: 'users',
  UserPlus: 'user-plus',
  XClose: 'x-close',
};

export default IconNames;
